const baseTrackingEvent = require('./BaseTrackingEvent');
const newRelicTracker = require('../NewRelic/NewRelicTracker');
const flexTracker = require('../Flex/FlexTracker');

module.exports = (flex = window.flex, FlexApiRequest = window.FlexApiRequest) => {

    const { isFlatObject } = flex;
    const BaseTrackingEvent = baseTrackingEvent(flex);
    const FlexTracker = flexTracker(FlexApiRequest);
    const NewRelicTracker = newRelicTracker(flex);

    class TrackingEvent extends BaseTrackingEvent {
        constructor(actionName = '') {
            super({ actionName, trackers: [new NewRelicTracker(), new FlexTracker()] });
        }

        track(valuesCollection = []) {
            if (typeof (valuesCollection) === 'object' && !(valuesCollection instanceof Array)) {
                valuesCollection = [valuesCollection];
            }

            let trackedValues = valuesCollection.reduce((trackedValues, valuesContainer) => {
                let error = false;

                if (!trackedValues) {
                    error = true;
                }

                let { prefix, values } = valuesContainer;

                if (!error && !isFlatObject(values)) {
                    console.error('To track an event, object for tracking must be a flat object. Exiting.', values);
                    error = true;
                }
                if (error) {
                    return false;
                }

                let keys = Object.keys(values);
                keys.forEach(key => {
                    let trackedKey = key;
                    if (prefix) {
                        trackedKey = `${prefix}:${key}`;
                    }

                    trackedValues[trackedKey] = values[key];
                });

                return trackedValues;
            }, {});

            if (!trackedValues) {
                return;
            }

            super.track(trackedValues)
        }
    }

    return TrackingEvent;
}